module.exports = __webpack_public_path__ + "static/media/clock.ab64ba8f.png";